import api from './api-service';
import _ from 'lodash';

const ASSET_TYPES_QUERY = `query getAssetTypes($offset: Int, $limit: Int, $search: String) {
  assetTypes (offset: $offset, limit: $limit, search: $search) {
  	totalCount
    nodes {
      id : name
      name
      label
      group
      category
      file
    }
  }
}`;

const AssetTypeService = {

	createInstance(data) {
		return {
			...data,
			filterByLength: () => {
				return [
					'tv-spot.us',
					'tv-spot.intl',
					'tv-spot.home-video',
					'film-clip.us',
					'film-clip.intl',
					'film-clip.home-video'
				].indexOf(data.name) > -1;
			}
		};
	},

	getAllAssetTypes(params) {
		return api.graphql.request(ASSET_TYPES_QUERY, params).then((res) => {
			return params ? res?.assetTypes ?? {} : res?.assetTypes?.nodes ?? [];
		});
	},
	postAssetType(data) {
		return new Promise((resolve, reject) => {
			api.client.post(`/assettypes`, data)
				.then(resolve)
				.catch((err) => {
					reject({
						code: 'ERROR',
						message: Object.keys(err.response.data).map((key) => _.get(err, `response.data.${key}[0]`,
							'Failed to create a new asset type'))[0]
					});
				});
		});
	},
	patchAssetType(data) {
		return new Promise((resolve, reject) => {
			api.client.patch(`/assettypes/${data.id}`, data)
				.then(resolve)
				.catch((err) => {
					reject({
						code: 'ERROR',
						message: Object.keys(err.response.data).map((key) => _.get(err, `response.data.${key}[0]`,
							'Failed to update the asset type'))[0]
					});
				});
		});
	},
	deleteAssetType({ name }) {
		return api.client.delete(`/assettypes/${name}`);
	}
};

export default AssetTypeService;
